import React from 'react'
import Pagination from '../Pagination/pagination';

import ServiceImg from '../../Assets/images/services-icon.png'
import { imgPath } from '../../Context/api';
const BranchView = ({ nestedtab, count, PER_PAGE, page, setNestedTab,data,exportData,  setData,  setPage, setNestedPage }) => {

    return (
        <>
            {
                !nestedtab?.show ?
                    <div className="row">
                        <div className="d-flex justify-content-end mb-1">
                            <button className='btn btn-primary' onClick={() => exportData('BRANCH')}>Export</button>
                        </div>
                        {
                            !data?.branchData?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                :
                                data?.branchData?.map((item) =>
                                    <div className="col-sm-12 col-md-6 col-lg-2 box cursor mt-2" key={item._id} onClick={() => { setData((pre) => ({ ...pre, branchId: item?._id })); setNestedTab((pre) => ({ ...pre, show: true })) }}>
                                        <div className="card text-center d-flex justify-content-center" style={{ minHeight: '20vh' }}>
                                            <h3 className='fw-bold'>{item.name}</h3>
                                            <h3><i className="fa-solid fa-location-dot"></i> {item?.city} ({item?.building})</h3>
                                        </div>
                                    </div>
                                )
                        }
                        <div className='w-100 d-flex justify-content-center'>
                            <div className='pagination_Position'>
                                {count > 10 &&
                                    <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                                }
                            </div>
                        </div>
                    </div>
                    :
                    !nestedtab.serviceShow ?
                        <>
                            {
                                nestedtab.tab === 1 &&
                                <>
                                    <p>Total Service Category : {data?.serviceCategory?.totalCount ? data?.serviceCategory?.totalCount : 0}</p>
                                    <div className="row">
                                        {
                                            data?.serviceCategory?.data?.map((item) =>
                                                <div className="col-sm-12 col-md-6 col-lg-2 box cursor mt-2" key={item._id} onClick={() => { setData((pre) => ({ ...pre, categoryId: item?._id })); setNestedTab((pre) => ({ ...pre, nestedPage: 1, serviceShow: true })) }}>
                                                    <div className="card text-center d-flex justify-content-center" style={{ minHeight: '20vh' }}>
                                                        <div className='d-flex justify-content-center'>
                                                            {
                                                                item.image === '' || item.image === null ?
                                                                    <img className="mx-auto img-fluid" src={item.image === '' || item.image === null ? ServiceImg : imgPath + item.image} height={50} width={50} alt="serviceImg" />
                                                                    :

                                                                    <img className="mx-auto img-fluid" src={imgPath + item.image} height={180} width={180} alt="serviceImg" />

                                                            }
                                                        </div>
                                                        <h3 className='fw-bold mt-2'>{item.name}</h3>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className='w-100 d-flex justify-content-center mt-2 '>
                                            <div className='pagination_Position'>
                                                {nestedtab?.nestedCount > 10 &&
                                                    <Pagination setpage={setNestedPage} count={Math.ceil(nestedtab?.nestedCount / PER_PAGE)} page={nestedtab?.nestedPage} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                nestedtab.tab === 2 &&
                                <>
                                    <div className="d-flex justify-content-between">
                                        <p>Total Team : {data?.teamData?.totalCount}</p>
                                        <button className='btn btn-primary' onClick={() => exportData('USER')}>Export</button>
                                    </div>
                                    <table className="table  shadow mt-3">
                                        <thead className="table-dark">
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                !data?.teamData?.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                                    :
                                                    <>
                                                        {
                                                            data?.teamData?.data?.map((item, index) => {
                                                                return <>
                                                                    <tr key={index}>
                                                                        <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                                        <td style={{ padding: '0.4rem .5rem' }}>{item?.name}</td>
                                                                        <td style={{ padding: '0.4rem .5rem' }}>{item?.email}</td>
                                                                        <td style={{ padding: '0.4rem .5rem' }}>{item?.mobileNo}</td>
                                                                    </tr>
                                                                </>
                                                            })
                                                        }
                                                    </>
                                            }
                                        </tbody>
                                    </table>
                                    <div className='w-100 d-flex justify-content-center'>
                                        <div className='w-100 d-flex justify-content-center mt-2'>
                                            <div className='pagination_Position'>
                                                {nestedtab?.nestedCount > 10 &&
                                                    <Pagination setpage={setNestedPage} count={Math.ceil(nestedtab?.nestedCount / PER_PAGE)} page={nestedtab?.nestedPage} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                        :
                        <>
                            <div className='d-flex justify-content-between'>
                                <div className='d-flex'>
                                    <i className="fa-solid fa-angle-left cusgap cursor" onClick={() => { setNestedTab((pre) => ({ ...pre, nestedPage: 1, serviceShow: false, tab: 1 })) }}></i>
                                    <p>Total Services : {data?.servicesData?.totalCount}</p>
                                </div>
                                <button className='btn btn-primary' onClick={() => exportData('SERVICE')}>Export</button>
                            </div>
                            <table className="table  shadow mt-3">
                                <thead className="table-dark">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Services</th>
                                        <th scope="col">Duration(Minutes)</th>
                                        <th scope="col">Regular Price</th>
                                        <th scope="col">Discount Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        !data?.servicesData?.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                            :
                                            <>
                                                {
                                                    data?.servicesData?.data?.map((item, index) => {
                                                        return <>
                                                            <tr key={index}>
                                                                <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                                <td style={{ padding: '0.4rem .5rem' }}> <img src={item.image === '' || item.image === null ? ServiceImg : imgPath + item.image} alt="" height={30} width={30} style={{ borderRadius: '50%' }} /></td>
                                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.name}</td>
                                                                <td style={{ padding: '0.4rem .5rem' }}>{item?.duration}</td>
                                                                <td style={{ padding: '0.4rem .5rem' }}>{item.fixedAmount}</td>
                                                                <td style={{ padding: '0.4rem .5rem' }}>{item.variableAmount}</td>
                                                            </tr>
                                                        </>
                                                    })
                                                }
                                            </>
                                    }
                                </tbody>
                            </table>
                            <div className='w-100 d-flex justify-content-center relative'>
                                <div className='w-100 d-flex justify-content-center mt-2 pagination_Position'>
                                    {nestedtab?.nestedCount > 10 &&
                                        <Pagination setpage={setNestedPage} count={Math.ceil(nestedtab?.nestedCount / PER_PAGE)} page={nestedtab?.nestedPage} />
                                    }
                                </div>
                            </div>
                        </>

            }
        </>
    )
}

export default BranchView